<template lang="pug">
  base-content(title="エンドユーザー様用申請書")
    base-app-selection(target="e")
</template>

<script>
import BaseContent from '@/components/BaseContent'
import BaseAppSelection from '@/components/BaseAppSelection'
export default {
  name: 'EnduserAppSelection',
  components: { BaseContent, BaseAppSelection }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EnduserAppSelection.vue